import type { Bar, Direction } from './types';

export type ResolverOutcome =
  | { kind: 'stop'; exitPrice: number }
  | { kind: 'target'; exitPrice: number }
  | { kind: 'open' };

export function resolveBar(
  direction: Direction,
  stop: number,
  target: number,
  bar: Bar,
): ResolverOutcome {
  if (direction === 'long') {
    if (bar.o <= stop) return { kind: 'stop', exitPrice: bar.o };
    if (bar.o >= target) return { kind: 'target', exitPrice: bar.o };
    const stopHit = bar.l <= stop;
    const targetHit = bar.h >= target;
    if (stopHit && targetHit) return { kind: 'stop', exitPrice: stop };
    if (targetHit) return { kind: 'target', exitPrice: target };
    if (stopHit) return { kind: 'stop', exitPrice: stop };
    return { kind: 'open' };
  }

  if (bar.o >= stop) return { kind: 'stop', exitPrice: bar.o };
  if (bar.o <= target) return { kind: 'target', exitPrice: bar.o };
  const stopHit = bar.h >= stop;
  const targetHit = bar.l <= target;
  if (stopHit && targetHit) return { kind: 'stop', exitPrice: stop };
  if (targetHit) return { kind: 'target', exitPrice: target };
  if (stopHit) return { kind: 'stop', exitPrice: stop };
  return { kind: 'open' };
}

export function computeRMultiple(
  direction: Direction,
  entry: number,
  stop: number,
  exitPrice: number,
): number {
  const risk = Math.abs(entry - stop);
  return direction === 'long' ? (exitPrice - entry) / risk : (entry - exitPrice) / risk;
}

export function computePnl(
  direction: Direction,
  entry: number,
  exitPrice: number,
  shares: number,
): number {
  return direction === 'long' ? (exitPrice - entry) * shares : (entry - exitPrice) * shares;
}

export function computeShares(
  equity: number,
  riskPct: number,
  entry: number,
  stop: number,
): { shares: number; riskAmount: number } {
  const riskAmount = equity * (riskPct / 100);
  const shares = riskAmount / Math.abs(entry - stop);
  return { shares, riskAmount };
}
